import { render, staticRenderFns } from "./diapositiva-15.vue?vue&type=template&id=7983d95e&scoped=true&"
var script = {}
import style0 from "./diapositiva-15.vue?vue&type=style&index=0&id=7983d95e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7983d95e",
  null
  
)

export default component.exports